import { withQualityFieldProfile } from "../qualityFieldProfile";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Checkbox,
  Card,
  CardContent,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Snackbar,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import viewsTexts from "../../../common/viewsTexts.json";
import {
  BreadCrumbs,
  CardHeaderWidget,
  SaveAction,
  SnackBarsComponent,
} from "../../../components";
import { AxiosContext } from "../../../context/AxiosContext";
import { Context } from "../../../context/Context";
import {
  alphabeticalSort,
  alterArrayGetFields,
  formatRut,
} from "../../../helpers";
import { BsCol, BsContainer, BsRow } from "../../../layouts/components";
// import theme from 'theme';
import SelectMultipleWidgetFilter from "components/SelectMultipleWidgetFilter";
import TextFieldWidgetText2 from "components/TextFieldWidget/TextFieldWidgetText2";
import {
  validateCleanAndFormatRut,
  validateRut,
} from "helpers/functionHelpers";
import { isGarcesFruitUser } from "../helperUsers";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.tertiary.main,
    fontWeight: 500,
  },
  divider: {
    background: theme.palette.grey[400],
    marginTop: 10,
  },
  rootHelper: {
    fontSize: 17,
  },
  inputText: {
    fontSize: 26,
  },
}));

const UserAdd = (props) => {
  const { userId } = useContext(Context);
  // const { state: filterState, addFilter } = useContext(FiltersContext);
  // const {
  //   // orchard_filter,
  //   // cc_filter,
  //   // quarter_filter,
  //   // variety_filter,
  //   // season_filter,
  //   userOrchard_filter,
  // } = filterState;

  const axiosContext = useContext(AxiosContext);

  const [showPassword, setShowPassword] = useState(false);
  const [loadingQueryState, setLoadingQueryState] = useState(false);
  const [successQueryState, setSuccessQueryState] = useState(false);
  const [profileDataState, setProfileDataState] = useState([]);
  const [loadingProfileDataState, setLoadingProfileDataState] = useState(false);
  const [loadingClientDataState, setLoadingClientDataState] = useState(false);
  const [clientDataState, setClientDataState] = useState([]);
  const [agroBusinessDataState, setAgroBusinessDataState] = useState([]);
  const [errorState, setErrorState] = useState(false);
  const [hideClientDataState, setHideClientDataState] = useState(false);

  // const theme = useTheme();
  // const classes = useStyles();
  // const [valueTabState, setValueTabState] = useState(0);
  // const handleChangeTab = (event, newValue) => {
  //   setValueTabState(newValue);
  // };

  const {
    handleSubmit,
    control,
    watch,
    reset,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const watchClient = watch("client");
  const watchProfile = watch("profile");
  const onSubmit = async (values) => {
    setLoadingQueryState(true);
    const profileSelected = profileDataState.filter(
      (ele) => ele.value === values.profile.value
    );

    // saca los objetos
    let clientObj = values.client
      ? clientDataState.filter((ele) => ele.value === values.client?.value)
      : null;

    clientObj = clientObj
      ? alterArrayGetFields(clientObj, ["id", "label", "value"])
      : null;
    const agroBusinessArray = values.agroBusiness
      ? values.agroBusiness.map((agro) => {
          const dataAgro = agroBusinessDataState.filter(
            (ele) => ele.value === agro.value
          );
          return dataAgro[0];
        })
      : "";

    if (values.rut) {
      if (!validateRut(values.rut)) {
        setError("rut", { type: "rutValido", message: "RUT inválido" });
        setLoadingQueryState(false);
        return;
      }
    }
    const query = {
      profile: profileSelected[0],
      email: values.email,
      rut: values.rut ? formatRut(values.rut) : "",
      client: clientObj ? clientObj[0] : null,
      agrobusiness: agroBusinessArray,
      name: values.name,
      lastname: values.lastName,
      username: values.userName,
      // maternalLastname: values.maternalLastname,
      phone: values.phone,
      password: values.password,
      whatsapp: !!values.whatsapp,
    };

    try {
      // const response = {
      //   status: 200,
      // };
      const response = await axiosContext.authAxios.post(
        "v1/user/create-user",
        query
      );

      if (response.status === 200) {
        setSuccessQueryState(true);

        reset({
          email: "",
          rut: "",
          name: "",
          lastName: "",
          phone: "",
          password: "",
          whatsapp: false,
        });
      }

      setLoadingQueryState(false);
    } catch (err) {
      console.log("Error", err.request.status);
      if (err.request.status === 500) {
        setErrorState(true);
      }

      setLoadingQueryState(false);
    }
  };

  const { password } = getValues();

  useEffect(() => {
    // console.log(watchClient, '-----watchClient');
    if (watchClient) {
      const resultClient = clientDataState.filter(
        (ele) => ele.value === watchClient.value
      );
      setAgroBusinessDataState(
        alphabeticalSort(resultClient[0].agrobusiness, "label")
      );
    }
  }, [watchClient]);

  const rutValue = watch("rut");

  useEffect(() => {
    if (rutValue === undefined) return;
    if (!rutValue) {
      clearErrors("rut");
      return;
    }
    const formatted = validateCleanAndFormatRut(rutValue);
    if (rutValue !== formatted) {
      setValue("rut", formatted, { shouldValidate: true });
    }
    // Validar solo si hay valor y el rut es válido
    if (!validateRut(formatted)) {
      setError("rut", { type: "rutValido", message: "RUT inválido" });
    } else {
      clearErrors("rut");
    }
  }, [rutValue, setValue, setError, clearErrors]);

  // endpoints
  useEffect(() => {
    getProfilesAsync();
    getClientsAsync();
  }, []);

  const getProfilesAsync = useCallback(async () => {
    setLoadingProfileDataState(true);
    try {
      let response = await axiosContext.authAxios.post(
        "v1/profile/list-profiles"
      );

      const { data, status } = response;

      if (status === 200) {
        let dataProfiles = alphabeticalSort(data.data, "label");

        dataProfiles = dataProfiles.map((profile) => {
          if (profile.value === "Administrador") {
            return {
              ...profile,
              label: `${profile.label} (JTP)`,
            };
          }
          return profile;
        });
        if (isGarcesFruitUser(userId)) {
          dataProfiles = dataProfiles.filter(
            (profile) => profile.value !== "Administrador_Panel"
          );
        }

        setProfileDataState(withQualityFieldProfile(dataProfiles));
      }
    } catch (error) {
      console.log(error);
      // setLoadingVarietyFilterState(false);
    } finally {
      setLoadingProfileDataState(false);
    }
  }, [axiosContext, setLoadingProfileDataState, setProfileDataState]);

  const getClientsAsync = useCallback(async () => {
    setLoadingClientDataState(true);
    try {
      let response = isGarcesFruitUser(userId)
        ? await axiosContext.authAxios.post("v1/client/list-clients", {
            value: "Garces_Fruit",
          })
        : await axiosContext.authAxios.post("v1/client/list-clients", {
            limit: 500,
          });

      const { data, status } = response;

      if (status === 200) {
        setClientDataState(alphabeticalSort(data.data, "label"));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingClientDataState(false);
    }
  }, [axiosContext, setLoadingClientDataState, setClientDataState]);

  const handleCloseSnackBarsComponent = () => {
    setErrorState(false);
  };

  useEffect(() => {
    // console.log(watchProfile, '----watchProfile');
    if (watchProfile && watchProfile === "Administrador_Panel") {
      setHideClientDataState(true);
    } else {
      setHideClientDataState(false);
    }
  }, [watchProfile]);

  const onCloseSnack = () => {
    setSuccessQueryState(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div className="form-style">
      <BsContainer fluid class="px-0 px-md-3">
        <BsRow class="no-gutters">
          <BsCol class="col-md-12">
            <Card elevation={0}>
              <CardHeaderWidget
                title={viewsTexts.titles.user.title}
                subheader={<BreadCrumbs subTitle="" />}
              />
              {/* <Divider /> */}
              <CardContent>
                <BsRow>
                  <BsCol class="col-md-12">
                    <form autoComplete="on" onSubmit={handleSubmit(onSubmit)}>
                      <BsRow>
                        <BsCol class="col-md-12">
                          <SelectMultipleWidgetFilter
                            options={profileDataState}
                            titleOption="label"
                            control={control}
                            name="profile"
                            labeltext="Perfil"
                            errors={errors.profile}
                            defaultValue=""
                            loading={loadingProfileDataState}
                            req
                            withDefault
                            variant="outlined"
                            placeholder="Seleccione El Perfil"
                            display="vertical"
                            minheight={false}
                            isClearable={true}
                            isSearchable
                            sizeSelect={"large"}
                            isMulti={false}
                          />
                        </BsCol>
                      </BsRow>
                      {!hideClientDataState ? (
                        <BsRow class="mt-4">
                          <BsCol class="col-md-6">
                            <SelectMultipleWidgetFilter
                              options={clientDataState}
                              titleOption="label"
                              control={control}
                              name="client"
                              labeltext="Cliente"
                              errors={errors.client}
                              defaultValue=""
                              loading={loadingClientDataState}
                              req
                              withDefault
                              variant="outlined"
                              placeholder="Seleccione el Cliente"
                              display="vertical"
                              minheight={false}
                              isClearable={true}
                              isSearchable
                              sizeSelect={"large"}
                              isMulti={false}
                            />
                          </BsCol>
                          <BsCol class="col-md-6">
                            <SelectMultipleWidgetFilter
                              options={agroBusinessDataState}
                              titleOption="label"
                              control={control}
                              name="agroBusiness"
                              labeltext="Agrícola"
                              errors={errors.agroBusiness}
                              multiple={true}
                              defaultValue={[]}
                              loading={false}
                              req
                              withDefault
                              variant="outlined"
                              placeholder="Seleccione la Agrícola"
                              display="vertical"
                              minheight={false}
                              isClearable={true}
                              isSearchable
                              sizeSelect={"large"}
                              isMulti={true}
                            />
                          </BsCol>
                        </BsRow>
                      ) : null}
                      <BsRow class="mt-3">
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="rut"
                            autoComplete="rut"
                            labeltext={viewsTexts.forms.rut}
                            placeholder="11.111.111-1"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            req={false}
                            defaultValue=""
                            control={control}
                            errors={errors.rut}
                            display="vertical"
                          />
                        </BsCol>
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="userName"
                            labeltext={viewsTexts.forms.userName}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            req={true}
                            defaultValue=""
                            minLength={3}
                            maxLength={12}
                            control={control}
                            errors={errors.userName}
                            display="vertical"
                          />
                        </BsCol>
                      </BsRow>
                      <BsRow class="mt-3">
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="name"
                            labeltext={viewsTexts.forms.name}
                            req={false}
                            defaultValue=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            minLength={3}
                            maxLength={100}
                            control={control}
                            errors={errors.name}
                            autoComplete="given-name"
                            display="vertical"
                          />
                        </BsCol>
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="lastName"
                            labeltext={viewsTexts.forms.lastName}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            req={false}
                            defaultValue=""
                            minLength={3}
                            maxLength={100}
                            control={control}
                            autoComplete="family-name"
                            errors={errors.lastName}
                            display="vertical"
                          />
                        </BsCol>
                      </BsRow>
                      <BsRow class="mt-3">
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="email"
                            labeltext={viewsTexts.forms.email}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            req={false}
                            defaultValue=""
                            control={control}
                            errors={errors.email}
                            autoComplete="email"
                            display="vertical"
                            type="email"
                          />
                        </BsCol>
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="phone"
                            labeltext={viewsTexts.forms.phone}
                            placeholder="56999999999"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            req={false}
                            defaultValue=""
                            minLength={8}
                            maxLength={11}
                            control={control}
                            autoComplete="phone"
                            errors={errors.phone}
                            display="vertical"
                            type="tel"
                          />
                        </BsCol>
                      </BsRow>
                      <BsRow class="mt-3">
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="password"
                            req={true}
                            minLength={6}
                            maxLength={12}
                            defaultValue=""
                            autoComplete="new-password"
                            type={showPassword ? "text" : "password"}
                            labeltext={viewsTexts.forms.password}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            control={control}
                            errors={errors.password}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    color="default"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            display="vertical"
                          />
                        </BsCol>
                        <BsCol class="col-md-6">
                          <TextFieldWidgetText2
                            name="password2"
                            equalto={password}
                            req={true}
                            type={showPassword ? "text" : "password"}
                            defaultValue=""
                            autoComplete="new-password"
                            minLength={6}
                            maxLength={12}
                            labeltext={viewsTexts.forms.password2}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            control={control}
                            errors={errors.password2}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    color="default"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            display="vertical"
                          />
                        </BsCol>
                      </BsRow>
                      <BsRow class="mt-2">
                        <BsCol class="col-md-12 text-center">
                          <Controller
                            name="whatsapp"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <FormControlLabel
                                label="Reportería Whatsapp"
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={!!field.value}
                                    onChange={(event) =>
                                      field.onChange(event.target.checked)
                                    }
                                  />
                                }
                              />
                            )}
                          />
                        </BsCol>
                      </BsRow>
                      <BsRow class="mt-5">
                        <BsCol class="col-md-12 text-center">
                          <SaveAction
                            title="Guardar"
                            color="secondary"
                            size="large"
                            className="roundedButton ml-md-2"
                            variant="contained"
                            disabled={loadingQueryState}
                            messageType="add"
                            mutationLoading={loadingQueryState}
                            success={successQueryState}
                            actionClose={onCloseSnack}
                          />
                        </BsCol>
                      </BsRow>
                    </form>
                  </BsCol>
                </BsRow>
                {errorState && (
                  <Snackbar
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    open={errorState}
                    onClose={() => setErrorState(false)}
                    autoHideDuration={4500}
                    key={Math.random()}
                  >
                    <SnackBarsComponent
                      variant="error"
                      message="El nombre de usuario ya existe"
                      handleClose={handleCloseSnackBarsComponent}
                    />
                  </Snackbar>
                )}
              </CardContent>
            </Card>
          </BsCol>
        </BsRow>
      </BsContainer>
    </div>
  );
};
export default UserAdd;
